'use client';

import React from 'react';
import GeneralSection from '../GeneralSection';
import Tabs from './Tabs';
import Summary from './Summary';
import IndustrySalary from './IndustrySalary';
import IndustryTrend from './IndustryTrend';
import SalaryRankRatio from './SalaryRankRatio';
import IndustryRatio from './IndustryRatio';
import NearCity from './NearCity';
import WorkDistribution from './WorkDistribution';
import LinksContainer from '../LinksContainer';
import RecommendPost from '@/components/seo/recommend-post';
import HighSalaryRank from '@/components/seo/high-salary-rank';
import JobOpportunityCard from '@/components/seo/JobOpportunityCard';
import CitySalaryRank from './CitySalaryRank';
import { CityContextType } from '@/types/city';
import { CascadeOptionType, SeoHotLinksType } from '@/types/common';
import { CityContext } from '@/context/create-context';
import {
  CITY_PAGE_RECRUITMENT_TREND_ID,
  CITY_PAGE_SALARY_INSIGHT_ID,
} from '@/constants/component-id';
import { getCityPagePosts } from '@/utils/articles';

type CityPropsType = {
  citiesDetail: CityContextType;
  existCities: CascadeOptionType[];
  seoHotLinks: SeoHotLinksType;
};

const City = (props: CityPropsType) => {
  const { citiesDetail, existCities, seoHotLinks } = props;

  return (
    <CityContext.Provider value={{ ...citiesDetail }}>
      <Tabs existCities={existCities} />
      <GeneralSection
        rightComponent={
          <>
            <RecommendPost fetchPosts={() => getCityPagePosts()} />
            <HighSalaryRank
              id={citiesDetail.market_share[0].id}
              name={citiesDetail.market_share[0].name}
              city={citiesDetail.pinyin}
            />
            <CitySalaryRank />
          </>
        }
        marginTop="mt-8"
      >
        <div id={CITY_PAGE_SALARY_INSIGHT_ID}>
          <Summary />
          <IndustrySalary />
          <IndustryTrend />
          <SalaryRankRatio />
          <NearCity />
        </div>
        <div id={CITY_PAGE_RECRUITMENT_TREND_ID}>
          <IndustryRatio />
          <WorkDistribution />
        </div>
        <LinksContainer
          seoHotLinks={seoHotLinks}
          city={{ pinyin: citiesDetail.pinyin, name: citiesDetail.name }}
        />
      </GeneralSection>
      {citiesDetail.job_opportunities &&
        citiesDetail.job_opportunities.length > 0 && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-8">热招职位</h3>
            <div className="grid gap-6 grid-cols-4 tablet:grid-rows-3">
              {citiesDetail.job_opportunities.map((item, index) => (
                <JobOpportunityCard key={item.id + index} data={item} />
              ))}
            </div>
          </div>
        )}
    </CityContext.Provider>
  );
};

export default City;
